var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingRightQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 81,
    viewBox: "0 0 102 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1758 80.9V66.8C65.5758 65 70.2758 61.7 74.2758 56.9C78.4758 52.1 80.5758 46.3 80.5758 39.5H60.7758V0.49999H101.276V35.9C101.276 48.7 97.1758 59 88.9758 66.8C80.9758 74.4 71.3758 79.1 60.1758 80.9ZM0.775782 80.9V66.8C6.17578 65 10.8758 61.7 14.8758 56.9C19.0758 52.1 21.1758 46.3 21.1758 39.5H1.37578V0.49999H41.8758V35.9C41.8758 48.7 37.7758 59 29.5758 66.8C21.5758 74.4 11.9758 79.1 0.775782 80.9Z",
    fill: "#00BA6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingRightQuotes);
export default __webpack_public_path__ + "static/media/landingRightQuotes.c0153c4c7396384349faa13c91f51420.svg";
export { ForwardRef as ReactComponent };